import { createEnvironment } from "@product/scmp-sdk";
import type { Environment } from "relay-runtime";

import { getAccountState, SCMPAccessTokenCookiesKey } from "~/lib/account";

import type { NetworkOptions } from "./network-options";
import { createNetworkOptions } from "./network-options";

let clientEnvironmentWithoutCred: Environment;

export function createBaseClientEnvironment(
  networkOption = {
    credentials: "omit",
  } as NetworkOptions,
) {
  return createEnvironment(
    createNetworkOptions({
      ...networkOption,
    }),
    {},
    {},
  );
}

export function createClientEnvironment() {
  if (typeof window === "undefined") return clientEnvironmentWithoutCred;
  const { accessToken } = getAccountState();
  if (clientEnvironmentWithoutCred === undefined) {
    clientEnvironmentWithoutCred = createBaseClientEnvironment({
      cookies: { [SCMPAccessTokenCookiesKey]: accessToken },
      credentials: "omit",
    });
  }

  return clientEnvironmentWithoutCred;
}

let clientEnvironmentWithCred: Environment;

export function createClientEnvironmentWithCred() {
  if (typeof window === "undefined") return clientEnvironmentWithCred;
  const { accessToken } = getAccountState();
  if (clientEnvironmentWithCred === undefined) {
    clientEnvironmentWithCred = createBaseClientEnvironment({
      cookies: { [SCMPAccessTokenCookiesKey]: accessToken },
      credentials: "include",
    });
  }

  return clientEnvironmentWithCred;
}
